import "./app.e0278e2b.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aEIUa", function(module, exports) {

$parcel$export(module.exports, "loadingIndicator", () => $7c2078fabb716a6f$export$f10e6b4aaa94c253);
/**
 * Show a loading state only when there is genuinely something to wait for.
 *
 * ── What was wrong ───────────────────────────────────────────────────────────
 *
 * The four pages that fetch their content shipped `<div id="loading">Loading…`
 * visible in the HTML, and hid it once the fetch resolved. That is right when
 * the fetch is slow and wrong the rest of the time, and the rest of the time is
 * most of the time.
 *
 * Measured on the live feed, on a repeat visit: `domContentLoaded` at 299ms,
 * the request for /api/v1/posts starting at 303ms and finishing at 305ms — two
 * milliseconds, served from the service worker's cache. The loader was on
 * screen from HTML parse until the module graph finished loading and running.
 * It was never waiting for data. It was waiting for JavaScript, with the answer
 * already in cache, and it flashed for roughly two hundred milliseconds every
 * single visit.
 *
 * ── What this does ───────────────────────────────────────────────────────────
 *
 * The element starts hidden in the markup, and is revealed only if the work is
 * still unfinished after a threshold. A fetch that resolves from cache never
 * reveals it; a cold visit, where the same request took over a second, does.
 *
 * That also fixes the announcement. These elements carry `role="status"` and
 * `aria-live="polite"`, so a screen reader announced "Loading…" on every visit
 * regardless. Now it is announced when it is true.
 *
 * ── On the threshold ─────────────────────────────────────────────────────────
 *
 * 250ms. Below roughly a tenth of a second a response reads as instant, and up
 * to a few tenths it reads as responsive; a spinner inside that window adds
 * noise and no information. Past it, silence starts to read as broken.
 *
 * It is deliberately not zero. A threshold of zero is the current behaviour
 * with extra steps.
 */ /** @type {number} */ const $7c2078fabb716a6f$var$DEFAULT_DELAY_MS = 250;
function $7c2078fabb716a6f$export$f10e6b4aaa94c253(element, delayMs = $7c2078fabb716a6f$var$DEFAULT_DELAY_MS) {
    if (!element) return ()=>{};
    element.hidden = true;
    const timer = setTimeout(()=>{
        element.hidden = false;
    }, delayMs);
    return ()=>{
        clearTimeout(timer);
        element.hidden = true;
    };
}

});

parcelRegister("egRyG", function(module, exports) {

$parcel$export(module.exports, "uploadToCloudinary", () => $a63c1aeba6c78780$export$ba8726098bbb8aef);
/**
 * media.js — uploading to Cloudinary, signed.
 *
 * Previously each page built its own FormData with `upload_preset` read from
 * `process.env.CLOUDINARY_UPLOAD_PRESET`. Parcel inlines those values at build
 * time, so the preset and cloud name were literals in the public bundles —
 * enough for anyone to upload to this Cloudinary account from anywhere, with no
 * sign-in required.
 *
 * Now the browser holds no upload credential at all. It asks the server for a
 * one-shot signature, which requires a valid session, and sends that instead.
 */ 
var $36CJS = parcelRequire("36CJS");
async function $a63c1aeba6c78780$export$ba8726098bbb8aef(file) {
    const { cloudName: cloudName, apiKey: apiKey, timestamp: timestamp, signature: signature } = await (0, $36CJS.api).uploads.signature();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('api_key', apiKey);
    fd.append('timestamp', timestamp);
    fd.append('signature', signature);
    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
        method: 'POST',
        body: fd
    });
    if (!res.ok) {
        const detail = await res.json().catch(()=>({}));
        throw new Error(detail?.error?.message || `Upload failed (${res.status})`);
    }
    return res.json();
}

});

parcelRegister("70R4S", function(module, exports) {
module.exports = import.meta.resolve("dJajv");

});

parcelRegister("gxv0g", function(module, exports) {

$parcel$export(module.exports, "GOTRUE_API_URL", () => $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1);
$parcel$export(module.exports, "initIdentityWidget", () => $c0a7c6fff4310ada$export$8c53c87b78e6fdd9);
$parcel$export(module.exports, "loadIdentityWidget", () => $c0a7c6fff4310ada$export$1259559fefbb46c);
$parcel$export(module.exports, "loadIdentityWidgetIfTokenPresent", () => $c0a7c6fff4310ada$export$267690839c122cee);
// Split out from auth-modal.js so pages with no sign-in UI (index, shows,
// studio) don't have to pull in the full custom auth modal — which builds
// and injects its whole login/signup DOM into the page as an import
// side-effect — just to initialize the Netlify Identity widget.
/**
 * This site's Identity (GoTrue) endpoint.
 *
 * Derived from wherever the page is served rather than hardcoded. The literal
 * production URL that used to live here meant a deploy preview authenticated
 * against production across origins — and, once this code is shared, that any
 * other band's deployment would silently sign users in against *this* band's
 * Identity instance.
 *
 * Locally this needs `netlify dev`, which serves /.netlify/identity on the dev
 * origin — the same thing the /api routes already require. Under a plain
 * `parcel serve` there is no Identity endpoint to talk to either way.
 */ const $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1 = `${window.location.origin}/.netlify/identity`;
function $c0a7c6fff4310ada$export$8c53c87b78e6fdd9() {
    window.netlifyIdentity?.init({
        APIUrl: $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1
    });
}
/**
 * The URL fragments Netlify Identity uses to hand a token to the page.
 *
 * These arrive from an email — confirm your address, reset your password,
 * accept an invite, confirm an address change. Visiting the link does not
 * confirm anything server-side; it drops the reader here with the token in the
 * hash, and only the initialised widget exchanges it for a session.
 */ const $c0a7c6fff4310ada$var$TOKEN_HASHES = [
    'confirmation_token=',
    'recovery_token=',
    'invite_token=',
    'email_change_token='
];
function $c0a7c6fff4310ada$export$d42ad5fbe912eace(hash = window.location.hash) {
    return $c0a7c6fff4310ada$var$TOKEN_HASHES.some((token)=>hash.includes(token));
}
/** @type {Promise<void> | null} */ let $c0a7c6fff4310ada$var$loading = null;
function $c0a7c6fff4310ada$export$1259559fefbb46c() {
    if ($c0a7c6fff4310ada$var$loading) return $c0a7c6fff4310ada$var$loading;
    $c0a7c6fff4310ada$var$loading = new Promise((resolve)=>{
        if (window.netlifyIdentity) return resolve();
        const script = document.createElement('script');
        script.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
        script.async = true;
        script.addEventListener('load', ()=>{
            $c0a7c6fff4310ada$export$8c53c87b78e6fdd9();
            resolve();
        });
        // Ad blockers and offline both land here. Callers degrade rather than hang.
        script.addEventListener('error', ()=>resolve());
        document.head.appendChild(script);
    });
    return $c0a7c6fff4310ada$var$loading;
}
function $c0a7c6fff4310ada$export$267690839c122cee() {
    if (!$c0a7c6fff4310ada$export$d42ad5fbe912eace()) return Promise.resolve();
    return $c0a7c6fff4310ada$export$1259559fefbb46c();
}

});

// ─── Constants ────────────────────────────────────────────────────────────────

var $3qsiv = parcelRequire("3qsiv");

var $aEIUa = parcelRequire("aEIUa");

var $egRyG = parcelRequire("egRyG");

var $5IRmI = parcelRequire("5IRmI");

var $36CJS = parcelRequire("36CJS");
// ─── Image cache invalidation ─────────────────────────────────────────────────
/**
 * Evict a Cloudinary URL from the image cache after a gallery item is deleted.
 *
 * @param {string} mediaUrl
 */ async function $1b8de847239bfd33$var$invalidateImageCache(mediaUrl) {
    if (!mediaUrl) return;
    try {
        if ('caches' in window) {
            const cache = await caches.open('sa-images-v1');
            await cache.delete(mediaUrl);
        }
        if ('serviceWorker' in navigator && navigator.serviceWorker.controller) navigator.serviceWorker.controller.postMessage({
            type: 'INVALIDATE_IMAGE',
            url: mediaUrl
        });
    } catch (err) {
        console.warn('[gallery] invalidateImageCache error:', err);
    }
}
// ─── State ────────────────────────────────────────────────────────────────────
/** @type {Array<{id:string, mediaUrl:string, mediaType:string, caption:string, createdAt:string}>} */ let $1b8de847239bfd33$var$galleryItems = [];
let $1b8de847239bfd33$var$lightboxIndex = 0;
let $1b8de847239bfd33$var$isAdmin = false;
// ─── DOM refs ─────────────────────────────────────────────────────────────────
const $1b8de847239bfd33$var$grid = document.getElementById('gallery-grid');
const $1b8de847239bfd33$var$loading = document.getElementById('loading');
const $1b8de847239bfd33$var$emptyState = document.getElementById('empty-state');
const $1b8de847239bfd33$var$errorState = document.getElementById('error-state');
const $1b8de847239bfd33$var$uploadBtn = document.getElementById('upload-btn');
// Lightbox
const $1b8de847239bfd33$var$lightbox = document.getElementById('lightbox');
const $1b8de847239bfd33$var$lightboxClose = document.getElementById('lightbox-close');
const $1b8de847239bfd33$var$lightboxWrap = document.getElementById('lightbox-media-wrap');
const $1b8de847239bfd33$var$lightboxPrev = document.getElementById('lightbox-prev');
const $1b8de847239bfd33$var$lightboxNext = document.getElementById('lightbox-next');
const $1b8de847239bfd33$var$lightboxCaption = document.getElementById('lightbox-caption');
const $1b8de847239bfd33$var$lightboxCounter = document.getElementById('lightbox-counter');
// Upload modal
const $1b8de847239bfd33$var$uploadModal = document.getElementById('upload-modal');
const $1b8de847239bfd33$var$modalClose = document.getElementById('modal-close');
const $1b8de847239bfd33$var$modalCancel = document.getElementById('modal-cancel');
const $1b8de847239bfd33$var$authGate = document.getElementById('gallery-auth-gate');
const $1b8de847239bfd33$var$loginBtn = document.getElementById('login-btn');
const $1b8de847239bfd33$var$uploadForm = document.getElementById('upload-form');
const $1b8de847239bfd33$var$mediaFileInput = document.getElementById('media-file');
const $1b8de847239bfd33$var$previewWrap = document.getElementById('media-preview-wrap');
const $1b8de847239bfd33$var$previewEl = document.getElementById('media-preview');
const $1b8de847239bfd33$var$removeMediaBtn = document.getElementById('remove-media-btn');
const $1b8de847239bfd33$var$mediaStatus = document.getElementById('media-status');
const $1b8de847239bfd33$var$captionInput = document.getElementById('media-caption');
const $1b8de847239bfd33$var$uploadSubmit = document.getElementById('upload-submit-btn');
const $1b8de847239bfd33$var$formStatus = document.getElementById('form-status');
// ─── Bootstrap ────────────────────────────────────────────────────────────────
(async ()=>{
    // Refresh an expired session (if a refresh token is available) before
    // initAuth()/initAuthBar() check it — otherwise a session past its 1-hour
    // access-token lifetime looks logged-out on every page load.
    await (0, $3qsiv.ensureFreshSession)();
    // initAuth() attaches identity.on() listeners; initAuthBar() (which
    // initializes the widget) must run after so it doesn't fire 'init' before
    // anything is listening for it.
    $1b8de847239bfd33$var$initAuth();
    (0, $3qsiv.initAuthBar)();
    $1b8de847239bfd33$var$registerServiceWorker();
    $1b8de847239bfd33$var$listenForSWMessages();
    // Before the await, deliberately. initAuth() has just unhidden #upload-btn,
    // so the button is visible and clickable from this point — but its click
    // handler lives in initUploadModal(). Running that after `await loadGallery()`
    // left a window where clicking Upload did nothing at all: no dialog, no
    // error, the event landing on a button with no listener.
    //
    // The window was short enough to look like it did not exist. Moving to
    // Postgres widened it — Neon scales to zero, so the first gallery fetch after
    // idle costs a few hundred milliseconds instead of a few. The browser suite
    // started failing here intermittently, which is what surfaced it.
    //
    // Neither of these needs gallery data: initUploadModal() wires the modal, and
    // initLightbox() attaches document-level handlers. The per-item click
    // handlers that do need data are attached by loadGallery() as it renders.
    $1b8de847239bfd33$var$initUploadModal();
    $1b8de847239bfd33$var$initLightbox();
    await $1b8de847239bfd33$var$loadGallery();
})();
// ─── Authentication ───────────────────────────────────────────────────────────
function $1b8de847239bfd33$var$initAuth() {
    const resolveUser = ()=>{
        const email = (0, $5IRmI.currentEmail)();
        return email ? {
            email: email
        } : null;
    };
    function applyUser(user) {
        $1b8de847239bfd33$var$isAdmin = !!user;
        // Show upload button and delete overlays only for logged-in users.
        // The server still enforces ALLOWED_AUTHORS — this is just UX convenience.
        if ($1b8de847239bfd33$var$uploadBtn) $1b8de847239bfd33$var$uploadBtn.hidden = !user;
        // Refresh delete button visibility on existing cards
        document.querySelectorAll('.gallery-item-delete').forEach((btn)=>{
            btn.hidden = !user;
        });
        // Swap auth gate ↔ upload form inside the modal
        if ($1b8de847239bfd33$var$authGate) $1b8de847239bfd33$var$authGate.hidden = !!user;
        if ($1b8de847239bfd33$var$uploadForm) $1b8de847239bfd33$var$uploadForm.hidden = !user;
    }
    applyUser(resolveUser());
    // The widget itself is initialized by initAuthBar() (called after initAuth()
    // in the bootstrap below) — these listeners must be attached first so it
    // doesn't fire 'init' before anything is listening for it.
    const identity = window.netlifyIdentity;
    if (identity) {
        identity.on('init', (user)=>applyUser(user || resolveUser()));
        identity.on('login', (user)=>{
            applyUser(user);
            identity.close();
        });
        identity.on('logout', ()=>{
            (0, $5IRmI.clearSession)();
            applyUser(null);
        });
    }
    // Custom auth-modal login event
    window.addEventListener('auth-modal:login', (e)=>{
        applyUser({
            email: e.detail.email
        });
    });
    // Login button inside the upload modal opens the custom auth modal
    $1b8de847239bfd33$var$loginBtn?.addEventListener('click', ()=>(0, $3qsiv.authModal).open('login'));
}
// ─── Silent background refresh ─────────────────────────────────────────────────
async function $1b8de847239bfd33$var$refreshGallerySilently() {
    try {
        $1b8de847239bfd33$var$galleryItems = await (0, $36CJS.api).gallery.list();
        $1b8de847239bfd33$var$grid.innerHTML = '';
        if (!$1b8de847239bfd33$var$galleryItems.length) {
            $1b8de847239bfd33$var$emptyState.hidden = false;
            return;
        }
        $1b8de847239bfd33$var$emptyState.hidden = true;
        $1b8de847239bfd33$var$galleryItems.forEach((item, idx)=>$1b8de847239bfd33$var$grid.appendChild($1b8de847239bfd33$var$renderThumbnail(item, idx)));
    } catch (err) {
        console.warn('[gallery] refreshGallerySilently error:', err);
    }
}

// ─── Service Worker registration + messages ────────────────────────────────────
function $1b8de847239bfd33$var$registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register((parcelRequire("70R4S")), {
        scope: '/'
    }).catch((err)=>console.warn('[gallery] SW registration failed:', err));
}
function $1b8de847239bfd33$var$listenForSWMessages() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.addEventListener('message', (e)=>{
        const { type: type, url: url } = e.data || {};
        // The SW revalidated /api/gallery/list in the background and found the
        // response actually changed — silently re-render instead of leaving
        // stale content on screen until the user manually reloads.
        if (type === 'API_UPDATED' && url?.includes('/api/gallery/list')) $1b8de847239bfd33$var$refreshGallerySilently();
    });
}
// ─── Gallery loading & rendering ─────────────────────────────────────────────
async function $1b8de847239bfd33$var$loadGallery() {
    const settled = (0, $aEIUa.loadingIndicator)($1b8de847239bfd33$var$loading);
    try {
        $1b8de847239bfd33$var$galleryItems = await (0, $36CJS.api).gallery.list();
        settled();
        if (!$1b8de847239bfd33$var$galleryItems.length) {
            $1b8de847239bfd33$var$emptyState.hidden = false;
            return;
        }
        $1b8de847239bfd33$var$galleryItems.forEach((item, idx)=>$1b8de847239bfd33$var$grid.appendChild($1b8de847239bfd33$var$renderThumbnail(item, idx)));
    } catch  {
        settled();
        if (!$1b8de847239bfd33$var$grid.children.length) $1b8de847239bfd33$var$errorState.hidden = false;
    }
}
/**
 * Build a thumbnail card for one gallery item.
 * @param {object} item
 * @param {number} idx  — index into galleryItems array
 */ function $1b8de847239bfd33$var$renderThumbnail(item, idx) {
    const article = document.createElement('article');
    article.className = 'gallery-item';
    article.setAttribute('role', 'listitem');
    article.dataset.idx = idx;
    const isVideo = item.mediaType === 'video' || $1b8de847239bfd33$var$isCloudinaryVideo(item.mediaUrl);
    if (isVideo) {
        // Generate an optimised poster frame via Cloudinary's video transformation
        const img = document.createElement('img');
        img.src = $1b8de847239bfd33$var$buildVideoPoster(item.mediaUrl, 400);
        img.alt = item.caption || 'Video thumbnail';
        img.loading = 'lazy';
        img.decoding = 'async';
        article.appendChild(img);
        const badge = document.createElement('span');
        badge.className = 'media-badge';
        badge.textContent = "\u25B6 video";
        article.appendChild(badge);
    } else {
        // Responsive square thumbnail — serve 1× and 2× via srcset so retina
        // screens get a sharper image without wasting bandwidth on 1× displays.
        const img = document.createElement('img');
        img.src = $1b8de847239bfd33$var$buildCloudinaryThumb(item.mediaUrl, 400);
        img.srcset = [
            `${$1b8de847239bfd33$var$buildCloudinaryThumb(item.mediaUrl, 200)} 200w`,
            `${$1b8de847239bfd33$var$buildCloudinaryThumb(item.mediaUrl, 400)} 400w`,
            `${$1b8de847239bfd33$var$buildCloudinaryThumb(item.mediaUrl, 600)} 600w`
        ].join(', ');
        // The grid uses auto-fill with a 200px minimum; 400px covers most cases.
        img.sizes = '(max-width: 480px) calc(50vw - 1em), (max-width: 768px) calc(33vw - 1em), 200px';
        img.alt = item.caption || 'Gallery photo';
        img.loading = 'lazy';
        img.decoding = 'async';
        article.appendChild(img);
    }
    // Caption overlay
    if (item.caption) {
        const caption = document.createElement('span');
        caption.className = 'gallery-item-caption';
        caption.textContent = item.caption;
        article.appendChild(caption);
    }
    // Delete button (admin only — visibility toggled by applyUser)
    const delBtn = document.createElement('button');
    delBtn.className = 'gallery-item-delete';
    delBtn.textContent = 'Delete';
    delBtn.hidden = !$1b8de847239bfd33$var$isAdmin;
    delBtn.setAttribute('aria-label', `Delete ${item.caption || 'this item'}`);
    delBtn.addEventListener('click', (e)=>{
        e.stopPropagation(); // don't open lightbox
        $1b8de847239bfd33$var$handleDelete(item, article);
    });
    article.appendChild(delBtn);
    // Open lightbox on click
    article.addEventListener('click', ()=>$1b8de847239bfd33$var$openLightbox(idx));
    return article;
}
// ─── Cloudinary URL helpers ───────────────────────────────────────────────────
/**
 * Transform a Cloudinary image URL to a square thumbnail of the given size.
 * Uses c_fill + g_auto (content-aware gravity), f_auto (WebP/AVIF), and
 * q_auto (quality ladder) for maximum compression with no visible quality loss.
 */ function $1b8de847239bfd33$var$buildCloudinaryThumb(url, size) {
    return url.replace('/upload/', `/upload/c_fill,g_auto,w_${size},h_${size},f_auto,q_auto/`);
}
/**
 * Build an optimised Cloudinary image URL for display at a given max width.
 * Preserves aspect ratio (c_limit), picks the best format (f_auto), and uses
 * Cloudinary's quality ladder (q_auto).
 */ function $1b8de847239bfd33$var$buildCloudinaryDisplay(url, maxWidth) {
    return url.replace('/upload/', `/upload/c_limit,w_${maxWidth},f_auto,q_auto/`);
}
/**
 * Build a srcset string for a Cloudinary image at several widths.
 * @param {string} url   - Original Cloudinary image URL
 * @param {number[]} widths - Array of pixel widths to generate descriptors for
 */ function $1b8de847239bfd33$var$buildCloudinarySrcset(url, widths) {
    return widths.map((w)=>`${$1b8de847239bfd33$var$buildCloudinaryDisplay(url, w)} ${w}w`).join(', ');
}
/**
 * Build an optimised video poster URL from a Cloudinary video URL.
 * Grabs frame at offset 0, converts to JPEG with auto quality, and
 * resizes to a reasonable thumbnail width.
 */ function $1b8de847239bfd33$var$buildVideoPoster(videoUrl, width = 400) {
    return videoUrl.replace('/video/upload/', `/video/upload/so_0,w_${width},f_auto,q_auto/`).replace(/\.[^.]+$/, '.jpg');
}
function $1b8de847239bfd33$var$isCloudinaryVideo(url) {
    return typeof url === 'string' && url.includes('/video/upload/');
}
// ─── Lightbox ─────────────────────────────────────────────────────────────────
function $1b8de847239bfd33$var$initLightbox() {
    $1b8de847239bfd33$var$lightboxClose.addEventListener('click', $1b8de847239bfd33$var$closeLightbox);
    $1b8de847239bfd33$var$lightboxPrev.addEventListener('click', ()=>$1b8de847239bfd33$var$navigateLightbox(-1));
    $1b8de847239bfd33$var$lightboxNext.addEventListener('click', ()=>$1b8de847239bfd33$var$navigateLightbox(1));
    // Close on backdrop click
    $1b8de847239bfd33$var$lightbox.addEventListener('click', (e)=>{
        if (e.target === $1b8de847239bfd33$var$lightbox) $1b8de847239bfd33$var$closeLightbox();
    });
    // Arrow keys page through the gallery. Escape is the browser's job now that
    // this is a <dialog> — it fires 'close', handled below.
    document.addEventListener('keydown', (e)=>{
        if (!$1b8de847239bfd33$var$lightbox.open) return;
        if (e.key === 'ArrowLeft') $1b8de847239bfd33$var$navigateLightbox(-1);
        if (e.key === 'ArrowRight') $1b8de847239bfd33$var$navigateLightbox(1);
    });
    // Runs however the dialog was dismissed: the close button, a backdrop click,
    // or Escape.
    $1b8de847239bfd33$var$lightbox.addEventListener('close', ()=>{
        document.body.style.overflow = '';
        $1b8de847239bfd33$var$lightboxWrap.querySelector('video')?.pause();
    });
}
function $1b8de847239bfd33$var$openLightbox(idx) {
    $1b8de847239bfd33$var$lightboxIndex = idx;
    $1b8de847239bfd33$var$renderLightboxItem();
    $1b8de847239bfd33$var$lightbox.showModal();
    document.body.style.overflow = 'hidden';
    $1b8de847239bfd33$var$lightboxClose.focus();
}
function $1b8de847239bfd33$var$closeLightbox() {
    if ($1b8de847239bfd33$var$lightbox.open) $1b8de847239bfd33$var$lightbox.close();
}
function $1b8de847239bfd33$var$navigateLightbox(delta) {
    const next = $1b8de847239bfd33$var$lightboxIndex + delta;
    if (next < 0 || next >= $1b8de847239bfd33$var$galleryItems.length) return;
    $1b8de847239bfd33$var$lightboxIndex = next;
    $1b8de847239bfd33$var$renderLightboxItem();
}
function $1b8de847239bfd33$var$renderLightboxItem() {
    const item = $1b8de847239bfd33$var$galleryItems[$1b8de847239bfd33$var$lightboxIndex];
    const isVideo = item.mediaType === 'video' || $1b8de847239bfd33$var$isCloudinaryVideo(item.mediaUrl);
    // Stop previous video if any
    const prevVideo = $1b8de847239bfd33$var$lightboxWrap.querySelector('video');
    if (prevVideo) prevVideo.pause();
    $1b8de847239bfd33$var$lightboxWrap.innerHTML = '';
    if (isVideo) {
        const video = document.createElement('video');
        video.controls = true;
        video.preload = 'metadata';
        video.setAttribute('playsinline', '');
        // Show an optimised poster while the video loads
        video.poster = $1b8de847239bfd33$var$buildVideoPoster(item.mediaUrl, 1200);
        const source = document.createElement('source');
        source.src = item.mediaUrl;
        video.appendChild(source);
        $1b8de847239bfd33$var$lightboxWrap.appendChild(video);
    } else {
        // Serve an optimised, format-negotiated image capped at 1600px wide —
        // wide enough for any lightbox but much smaller than the raw original.
        const img = document.createElement('img');
        img.src = $1b8de847239bfd33$var$buildCloudinaryDisplay(item.mediaUrl, 1600);
        img.srcset = $1b8de847239bfd33$var$buildCloudinarySrcset(item.mediaUrl, [
            800,
            1200,
            1600
        ]);
        img.sizes = '(max-width: 900px) 100vw, 1100px';
        img.alt = item.caption || 'Gallery photo';
        img.decoding = 'async';
        $1b8de847239bfd33$var$lightboxWrap.appendChild(img);
    }
    $1b8de847239bfd33$var$lightboxCaption.textContent = item.caption || '';
    $1b8de847239bfd33$var$lightboxCounter.textContent = `${$1b8de847239bfd33$var$lightboxIndex + 1} / ${$1b8de847239bfd33$var$galleryItems.length}`;
    $1b8de847239bfd33$var$lightboxPrev.disabled = $1b8de847239bfd33$var$lightboxIndex === 0;
    $1b8de847239bfd33$var$lightboxNext.disabled = $1b8de847239bfd33$var$lightboxIndex === $1b8de847239bfd33$var$galleryItems.length - 1;
}
// ─── Upload modal ─────────────────────────────────────────────────────────────
function $1b8de847239bfd33$var$initUploadModal() {
    $1b8de847239bfd33$var$uploadBtn?.addEventListener('click', $1b8de847239bfd33$var$openUploadModal);
    $1b8de847239bfd33$var$modalClose?.addEventListener('click', $1b8de847239bfd33$var$closeUploadModal);
    $1b8de847239bfd33$var$modalCancel?.addEventListener('click', $1b8de847239bfd33$var$closeUploadModal);
    // Close on backdrop click
    $1b8de847239bfd33$var$uploadModal?.addEventListener('click', (e)=>{
        if (e.target === $1b8de847239bfd33$var$uploadModal) $1b8de847239bfd33$var$closeUploadModal();
    });
    // Keyboard close
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && $1b8de847239bfd33$var$uploadModal?.open) $1b8de847239bfd33$var$closeUploadModal();
    });
    // File picker
    let selectedFile = null;
    $1b8de847239bfd33$var$mediaFileInput?.addEventListener('change', async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        $1b8de847239bfd33$var$clearStatus($1b8de847239bfd33$var$mediaStatus);
        selectedFile = null;
        $1b8de847239bfd33$var$previewWrap.hidden = true;
        $1b8de847239bfd33$var$previewEl.innerHTML = '';
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        if (!isImage && !isVideo) {
            $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$mediaStatus, 'Only images and videos are supported.', 'error');
            $1b8de847239bfd33$var$mediaFileInput.value = '';
            return;
        }
        if (isVideo) try {
            const duration = await $1b8de847239bfd33$var$getVideoDuration(file);
            if (duration > 300) {
                $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$mediaStatus, 'Videos must be under 5 minutes.', 'error');
                $1b8de847239bfd33$var$mediaFileInput.value = '';
                return;
            }
        } catch  {
            $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$mediaStatus, 'Could not read video metadata.', 'error');
            $1b8de847239bfd33$var$mediaFileInput.value = '';
            return;
        }
        selectedFile = {
            file: file,
            type: isImage ? 'image' : 'video'
        };
        // Local preview
        const objectUrl = URL.createObjectURL(file);
        if (isVideo) {
            const vid = document.createElement('video');
            vid.src = objectUrl;
            vid.controls = true;
            vid.preload = 'metadata';
            vid.setAttribute('playsinline', '');
            $1b8de847239bfd33$var$previewEl.appendChild(vid);
        } else {
            const img = document.createElement('img');
            img.src = objectUrl;
            img.alt = 'Preview';
            $1b8de847239bfd33$var$previewEl.appendChild(img);
        }
        $1b8de847239bfd33$var$previewWrap.hidden = false;
        // Expose selectedFile to form submit handler via closure
        $1b8de847239bfd33$var$uploadForm._selectedFile = selectedFile;
    });
    $1b8de847239bfd33$var$removeMediaBtn?.addEventListener('click', ()=>{
        $1b8de847239bfd33$var$mediaFileInput.value = '';
        $1b8de847239bfd33$var$previewWrap.hidden = true;
        $1b8de847239bfd33$var$previewEl.innerHTML = '';
        $1b8de847239bfd33$var$clearStatus($1b8de847239bfd33$var$mediaStatus);
        if ($1b8de847239bfd33$var$uploadForm) $1b8de847239bfd33$var$uploadForm._selectedFile = null;
    });
    $1b8de847239bfd33$var$uploadForm?.addEventListener('submit', $1b8de847239bfd33$var$handleUpload);
}
function $1b8de847239bfd33$var$openUploadModal() {
    $1b8de847239bfd33$var$uploadModal?.showModal();
    document.body.style.overflow = 'hidden';
}
function $1b8de847239bfd33$var$closeUploadModal() {
    if ($1b8de847239bfd33$var$uploadModal?.open) $1b8de847239bfd33$var$uploadModal.close();
    document.body.style.overflow = '';
    $1b8de847239bfd33$var$resetUploadForm();
}
function $1b8de847239bfd33$var$resetUploadForm() {
    $1b8de847239bfd33$var$uploadForm?.reset();
    $1b8de847239bfd33$var$previewWrap.hidden = true;
    $1b8de847239bfd33$var$previewEl.innerHTML = '';
    $1b8de847239bfd33$var$clearStatus($1b8de847239bfd33$var$mediaStatus);
    $1b8de847239bfd33$var$clearStatus($1b8de847239bfd33$var$formStatus);
    if ($1b8de847239bfd33$var$uploadForm) $1b8de847239bfd33$var$uploadForm._selectedFile = null;
}
async function $1b8de847239bfd33$var$handleUpload(e) {
    e.preventDefault();
    const selectedFile = $1b8de847239bfd33$var$uploadForm._selectedFile;
    if (!selectedFile) {
        $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$formStatus, 'Please select a photo or video.', 'error');
        return;
    }
    $1b8de847239bfd33$var$uploadSubmit.disabled = true;
    $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$formStatus, "Uploading\u2026", '');
    try {
        let fileToUpload = selectedFile.file;
        // Compress images before upload
        if (selectedFile.type === 'image') {
            $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$mediaStatus, "Compressing image\u2026", 'uploading');
            try {
                fileToUpload = await $1b8de847239bfd33$var$compressImage(selectedFile.file);
            } catch  {
                fileToUpload = selectedFile.file; // fall back to original
            }
        }
        $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$mediaStatus, "Uploading to Cloudinary\u2026", 'uploading');
        const cloudResult = await (0, $egRyG.uploadToCloudinary)(fileToUpload);
        $1b8de847239bfd33$var$clearStatus($1b8de847239bfd33$var$mediaStatus);
        const mediaUrl = cloudResult.secure_url;
        const mediaType = selectedFile.type;
        const caption = $1b8de847239bfd33$var$captionInput?.value.trim() || '';
        const newItem = await (0, $36CJS.api).gallery.add({
            mediaUrl: mediaUrl,
            mediaType: mediaType,
            caption: caption
        });
        // Prepend to local array and grid
        $1b8de847239bfd33$var$galleryItems.unshift(newItem);
        // Re-index all existing cards
        document.querySelectorAll('.gallery-item').forEach((card)=>{
            card.dataset.idx = String(Number(card.dataset.idx) + 1);
        });
        const card = $1b8de847239bfd33$var$renderThumbnail(newItem, 0);
        $1b8de847239bfd33$var$grid.insertBefore(card, $1b8de847239bfd33$var$grid.firstChild);
        $1b8de847239bfd33$var$emptyState.hidden = true;
        $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$formStatus, "\u2713 Uploaded!", 'success');
        setTimeout($1b8de847239bfd33$var$closeUploadModal, 1200);
    } catch (err) {
        console.error('[gallery] upload error:', err);
        $1b8de847239bfd33$var$setStatus($1b8de847239bfd33$var$formStatus, `\u{2715} ${err.message}`, 'error');
    } finally{
        $1b8de847239bfd33$var$uploadSubmit.disabled = false;
    }
}
// ─── Delete ───────────────────────────────────────────────────────────────────
async function $1b8de847239bfd33$var$handleDelete(item, cardEl) {
    if (!confirm(`Delete this ${item.mediaType || 'item'}? This cannot be undone.`)) return;
    try {
        await (0, $36CJS.api).gallery.remove(item.id);
        // Remove from local state and DOM
        const idx = $1b8de847239bfd33$var$galleryItems.findIndex((i)=>i.id === item.id);
        if (idx !== -1) $1b8de847239bfd33$var$galleryItems.splice(idx, 1);
        cardEl.remove();
        // Evict the deleted item's media from the SW image cache.
        await $1b8de847239bfd33$var$invalidateImageCache(item.mediaUrl);
        // Re-index remaining cards
        document.querySelectorAll('.gallery-item').forEach((card, i)=>{
            card.dataset.idx = i;
        });
        if (!$1b8de847239bfd33$var$galleryItems.length) $1b8de847239bfd33$var$emptyState.hidden = false;
    } catch (err) {
        console.error('[gallery] delete error:', err);
        alert(`Could not delete: ${err.message}`);
    }
}
// ─── Media helpers ────────────────────────────────────────────────────────────
async function $1b8de847239bfd33$var$compressImage(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = (ev)=>{
            const img = new Image();
            img.onerror = reject;
            img.onload = ()=>{
                const MAX_W = 2400;
                const MAX_H = 1600;
                let { width: width, height: height } = img;
                if (width > MAX_W) {
                    height = Math.round(height * MAX_W / width);
                    width = MAX_W;
                }
                if (height > MAX_H) {
                    width = Math.round(width * MAX_H / height);
                    height = MAX_H;
                }
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error('Canvas toBlob failed')), 'image/webp', 0.85);
            };
            img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
    });
}
function $1b8de847239bfd33$var$getVideoDuration(file) {
    return new Promise((resolve, reject)=>{
        const video = document.createElement('video');
        video.preload = 'metadata';
        const src = URL.createObjectURL(file);
        video.onloadedmetadata = ()=>{
            URL.revokeObjectURL(src);
            resolve(video.duration);
        };
        video.onerror = ()=>{
            URL.revokeObjectURL(src);
            reject(new Error('Could not read video'));
        };
        video.src = src;
    });
}
// ─── UI helpers ───────────────────────────────────────────────────────────────
function $1b8de847239bfd33$var$setStatus(el, text, cls) {
    if (!el) return;
    el.textContent = text;
    el.className = cls;
}
function $1b8de847239bfd33$var$clearStatus(el) {
    if (!el) return;
    el.textContent = '';
    el.className = '';
}


//# sourceMappingURL=gallery.15474a36.js.map
